import React, { useState } from 'react';
import NewsCard from '../../components/gallery/NewsCard';
import { newsArticles, newsCategories } from '../../data/news';
import './News.css';

const News = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredNews = selectedCategory === 'All' 
    ? newsArticles 
    : newsArticles.filter(article => article.category === selectedCategory);

  // Sort by date (newest first)
  const sortedNews = [...filteredNews].sort((a, b) => new Date(b.date) - new Date(a.date));

  // Get the latest/featured article
  const featuredArticle = sortedNews[0];
  const regularArticles = sortedNews.slice(1);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="page-content">
      {/* Hero Section */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['article', 'newspaper', 'campaign', 'notifications', 'announcement', 'edit_note', 'feed', 'description'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Company Updates
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              News & Updates
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Stay informed about our latest projects and company news
            </p>
          </div>
        </div>
      </section>

      {/* News Content */}
      <section className="section">
        <div className="news-container">
          {/* Featured Article */}
          {featuredArticle && (
            <>
              <div className="section-header">
                <h2>Featured Story</h2>
              </div>
              
              <div className="featured-article">
                <div className="featured-article-grid">
                  <div className="featured-article-image">
                    <div className="featured-article-icon">
                      <span className="material-icons">article</span>
                    </div>
                    <div className="featured-article-badge">
                      {featuredArticle.category}
                    </div>
                  </div>
                  
                  <div className="featured-article-content">
                    <div className="featured-article-date">
                      <span className="material-icons">calendar_today</span>
                      <span>{formatDate(featuredArticle.date)}</span>
                    </div>
                    
                    <h2 className="featured-article-title">
                      {featuredArticle.title}
                    </h2>
                    
                    <p className="featured-article-excerpt">
                      {featuredArticle.excerpt}
                    </p>
                    
                    <a 
                      href={`/news/${featuredArticle.id}`}
                      className="featured-article-button"
                    >
                      <span>Read Full Story</span>
                      <span className="material-icons">arrow_forward</span>
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Category Filter */}
          <div className="news-filters">
            {newsCategories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`filter-button ${selectedCategory === category ? 'active' : ''}`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* News Grid */}
          <div className="news-grid">
            {regularArticles.map((article) => (
              <NewsCard key={article.id} article={article} />
            ))}
          </div>

          {/* No Results Message */}
          {regularArticles.length === 0 && filteredNews.length <= 1 && (
            <div className="no-results">
              <p>No news articles found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default News;

